export default __webpack_public_path__ + "static/media/sa--dropdown.67ea7918.webp";